import React, { type MutableRefObject, type ReactNode } from 'react';
import { StickyContainer } from '@secretescapes/falcon';
import { useAppState } from '@utils/useAppState';
import { useApplicationState } from '@utils/useApplicationState';
import { useIsStickyObserver } from '../IntersectionObservers';
import {
  OuterContainer,
  StickyContainerWrapper,
  StickyElementContainer,
} from './StickyNavigation.styles';

export const STICKY_CONTAINER_TEST_ID = 'sticky-container';

export interface StickyNavigationProps {
  stickyRef?: MutableRefObject<HTMLDivElement | null>;
  navigation: ReactNode;
  children: ReactNode;
}

export const StickyNavigation = ({
  stickyRef = { current: null },
  navigation,
  children,
}: StickyNavigationProps) => {
  const { isMobile } = useApplicationState();
  const { finalRates } = useAppState();
  const { isSticky } = useIsStickyObserver(stickyRef);

  const isNavSticky = isSticky && (!isMobile || !finalRates.show);

  return (
    <StickyContainerWrapper isSticky={isNavSticky}>
      <StickyContainer
        zIndex={5}
        dataAttributes={{ testid: STICKY_CONTAINER_TEST_ID }}
        stickyElement={
          <OuterContainer isMobile={isMobile}>
            <StickyElementContainer ref={stickyRef} isSticky={isNavSticky} isMobile={!!isMobile}>
              {navigation}
            </StickyElementContainer>
          </OuterContainer>
        }
      >
        {children}
      </StickyContainer>
    </StickyContainerWrapper>
  );
};
